import { Fragment, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Box, Grid, Stack, Tab, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Card } from "../../ui/Card";
import { StyledSeperator } from "../../ui/Seperator";
import { getOrderDetails } from "./orderApi";
import BreadCrumbs from "../../ui/BreadCrumbs";

interface PackageDetails {
  description: string;
  height: number;
  length: number;
  weight: number;
  width: number;
}

export interface IndvOrder {
  comments: string;
  created: string;
  description: string;
  expected_delivery: string | null;
  guid: string | null;
  id: number;
  invoice_invoice_number: string | null;
  invoice_status: string | null;
  number_pieces: number;
  package_details: PackageDetails[];
  pickedup_time: null;
  pickup_cnumber: null;
  pickup_ready_time: null;
  receiver_address_address: string;
  receiver_address_city: string;
  receiver_contact_person_name: string;
  return_guid: null;
  selected_quote_service_vendor_name: string;
  shipment_tag: string;
  shipper_address_address: string;
  shipper_address_city: string;
  shipper_contact_person_name: string;
  status: string;
  track_time: null;
  weight: number;
  invoice_value: number;
  amount: number;
  shipment_invoice_invoice_number: number;
  shipment_invoice_status: string;
  order_channel: string;
}
interface OrderActivity {
  date: string;
  title: string;
  message?: string;
}

const OrderDetails = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const { order_id } = useParams();

  const [order, setOrder] = useState<IndvOrder>();
  const [orderActivity, setOrderActivity] = useState<OrderActivity[]>();

  useEffect(() => {
    if (order_id) {
      getOrderDetails(order_id)
        .then((data) => {
          console.log(data.data?.data);
          setOrder(data.data?.data?.order_detail);
          setOrderActivity(data.data?.data?.activity_logs);
        })
        .catch((err) => {
          toast.error("Order with that id doesn't exist!");
          navigate("/order");
        });
    }
  }, []);

  const createdDate = new Date(order?.created as string);

  return (
    <>
      {order && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BreadCrumbs
              field="Order"
              link={location.state?.prevurl || "/order"}
              extra={[
                {
                  text: "Add Order",
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={9}>
            <Stack rowGap={2}>
              <Card>
                <Typography fontWeight={"500"}>Order Details</Typography>
                <StyledSeperator />
                <Grid container spacing={2}>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>
                      Order created on channel
                    </Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {`${createdDate.toUTCString()}`}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Shipper Name</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.shipper_contact_person_name}
                    </Typography>
                  </Grid>

                  <Grid item md={6} sm={6} xs={12}>
                    <Typography fontSize={11}>Pickup Address</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.shipper_address_address}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Pickup City</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.shipper_address_city}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Amount</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.amount && `Rs. ${order?.amount}`}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Service</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.selected_quote_service_vendor_name}
                    </Typography>
                  </Grid>

                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>AWB Number</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.guid}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Number Pieces</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.number_pieces}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Shipment Invoice Number</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.shipment_invoice_invoice_number}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Shipment Invoice Status</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.shipment_invoice_status}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Pickup Ready Time</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.pickup_ready_time}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Status</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.status}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Track Time</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.track_time}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Pickedup Time</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.pickedup_time}
                    </Typography>
                  </Grid>
                  {/* <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Return Guid</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.return_guid}
                    </Typography>
                  </Grid> */}
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Expected Delivery</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.expected_delivery}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>comments</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.comments}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Pickup Number</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.pickup_cnumber}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Shipment Tag</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.shipment_tag}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Invoice Value</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.invoice_value}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Order Channel</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.order_channel}
                    </Typography>
                  </Grid>

                </Grid>
                <StyledSeperator />
                <Typography fontWeight={"500"}>Package Details</Typography>
                <StyledSeperator />

                {order.package_details &&
                  order?.package_details.map((el, index) => {
                    return (
                      <Fragment key={index}>
                        <Grid container spacing={2} sx={{ margin: "10px 0px" }}>
                          <Grid item md={3} sm={6} xs={12}>
                            <Typography fontSize={11}>
                              Dead Weight (in Kg)
                            </Typography>
                            <Typography fontSize={12} fontWeight={600}>
                              {el.weight}
                            </Typography>
                          </Grid>
                          <Grid item md={3} sm={6} xs={12}>
                            <Typography fontSize={11}>
                              Dimensions (in cm)
                            </Typography>
                            <Typography fontSize={12} fontWeight={600}>
                              {el.length} L * {el.width} W * {el.height} H
                            </Typography>
                          </Grid>
                          <Grid item md={3} sm={6} xs={12}>
                            <Typography fontSize={11}>Description</Typography>
                            <Typography fontSize={12} fontWeight={600}>
                              {el.description}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Fragment>
                    );
                  })}
                <StyledSeperator />
                <Typography fontWeight={"500"}>Customer Details</Typography>
                <StyledSeperator />
                <Grid container spacing={2}>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>Name</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.receiver_contact_person_name}
                    </Typography>
                  </Grid>
                  <Grid item md={6} sm={6} xs={12}>
                    <Typography fontSize={11}>Address</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.receiver_address_address}
                    </Typography>
                  </Grid>
                  <Grid item md={3} sm={6} xs={12}>
                    <Typography fontSize={11}>City</Typography>
                    <Typography fontSize={12} fontWeight={600}>
                      {order?.receiver_address_city}
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            </Stack>
          </Grid>
          <Grid item md={3} sm={12} xs={12}>
            <Card>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                }}
              >
                <Tab label="Activity log" />
              </Box>

              {orderActivity?.map((oActivity, index) => (
                <Fragment key={index}>
                  <Stack
                    sx={{
                      marginTop: "10px",
                      backgroundColor: "#c7c7c73d3",
                      borderRadius: "4px",
                      boxShadow: "1px 1px 3px #d3d3d3",
                    }}
                    padding={"10px"}
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    gap={"10px"}
                    rowGap={"10px"}
                  >
                    {oActivity?.message && (
                      <Typography fontSize={"14px"} bgcolor="background.level1">
                        {oActivity.message}
                      </Typography>
                    )}
                    <Typography fontSize={"14px"} bgcolor="background.level1">
                      {oActivity.date ? `${oActivity.date} :` : ""}
                    </Typography>
                    <Typography fontSize={"14px"} bgcolor="background.level1">
                      {oActivity.title}
                    </Typography>
                  </Stack>
                </Fragment>
              ))}
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default OrderDetails;
